import { signal } from "@preact/signals-react"
import { useEffect } from "react"
import { fetchUtg } from "../utils/api"

// import { withGeneralErrorHandling } from "./withGeneralErrorHandling"
import { addNotification } from "../stores/notification-store"

export const loading = signal(false)
export const error = signal(null)
export const utg = signal({})
export const modified = signal(false) // allows a component to flag the data as modified so subsequent calls to the hook will reload it
export const parameterHash = signal(null)

const fetchData = async (businessEntityId, componentId, config, accessToken) => {

    const hash = await import('object-hash').then(module => module.default || module)
    // if any parameters have changed then flag as modified so that the hook will reload the data
    const currentParametersHash = hash([businessEntityId, componentId, config, accessToken])
    if (currentParametersHash != parameterHash.value) {
        modified.value = true
        parameterHash.value = currentParametersHash
    }

    // short-circuit if we have a pending request or have already received an error
    if (loading.value || error.value || !config || !modified.value) {
        return
    }

    // short-circuit if we already have the utg data
    if (utg && utg.value && utg.value.ComponentId == componentId) {
        return
    }
    if (businessEntityId && componentId && config && accessToken) {
        try {
            loading.value = true
            utg.value = await fetchUtg(businessEntityId, componentId, config, accessToken)
            
        } catch (err) {
            error.value = err
            addNotification(`Unable to load data - ${err}`)
        }
        finally {
            loading.value = false
            modified.value = false
        }
    }
    
}

export default function useUtgData(businessEntityId, componentId, config, accessToken) {
    useEffect(() => {
        fetchData(businessEntityId, componentId, config, accessToken)
    }, [businessEntityId, componentId, config, accessToken])

    return {
        utg, loading, error
    }
}